import { put, takeEvery, takeLatest } from "redux-saga/effects";
import { danhSachTotNghiepApi } from "../../../api/xet-tot-nghiep/danhSachTotNghiepApi";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { eDanhSachTotNghiepActionIds, IDanhSachTotNghiepActionTypes } from "../../action-types/xet-tot-nghiep/IDanhSachTotNghiepActions";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { IDanhSachTotNghiepUpdateTrangThaiRequest } from "../../../model/request/xet-tot-nghiep/IDanhSachTotNghiepUpdateTrangThaiRequest";
import { IDanhSachTotNghiepUpdateQuyetDinhRequest } from "../../../model/request/xet-tot-nghiep/IDanhSachTotNghiepUpdateQuyetDinhRequest";
import { IGenerateSoVaoSoRequest } from "../../../model/request/xet-tot-nghiep/IGenerateSoVaoSoRequest";
import { IGenerateSoHieuRequest } from "../../../model/request/xet-tot-nghiep/IGenerateSoHieuRequest";
import { IGenerateSoInQuyetDinhRequest } from "../../../model/request/xet-tot-nghiep/IGenerateSoInQuyetDinhRequest";
import { IHuyKetQuaXetTotNghiepRequest } from "../../../model/request/xet-tot-nghiep/IHuyKetQuaXetTotNghiepRequest";
import { NotifyHelper } from "../../../helpers/toast"; 
const mainActions = rootActions.xetTotNghiep.danhSachTotNghiep;

export function* danhSachTotNghiepSaga(): any {
    yield takeLatest(eDanhSachTotNghiepActionIds.LOAD_BY_DOT_XET_START, loadWorker);
    yield takeEvery(eDanhSachTotNghiepActionIds.UPDATE_TRANG_THAI_START, updateTrangThaiWorker);
    yield takeEvery(eDanhSachTotNghiepActionIds.UPDATE_QUYET_DINH_START, updateQuyetDinhWorker);
    yield takeEvery(eDanhSachTotNghiepActionIds.UPDATE_SO_HIEU_START, updateSoHieuWorker);
    yield takeEvery(eDanhSachTotNghiepActionIds.UPDATE_SO_VAO_SO_START, updateSoVaoSoWorker);
    yield takeEvery(eDanhSachTotNghiepActionIds.HUY_KET_QUA_XET_TOT_NGHIEP_START, huyKetQuaXetTotNghiepWorker);
    yield takeLatest(eDanhSachTotNghiepActionIds.UPDATE_SO_IN_QUYET_DINH_START, updateSoInQuyetDinhWorker);
}

function* loadWorker(action: IDanhSachTotNghiepActionTypes) : any {
    const id_dot_xet = action.payload as number;
    const response: IBaseResponse = yield danhSachTotNghiepApi.SelectByDotXet(id_dot_xet);
    if (response.is_success) {
        yield put(mainActions.LOAD_BY_DOT_XET_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(mainActions.LOAD_BY_DOT_XET_ERROR(response.message ?? "Không thể tải danh sách tốt nghiệp"));
    }
}

function* updateTrangThaiWorker(action: IDanhSachTotNghiepActionTypes) : any {
    const payload = action.payload as IDanhSachTotNghiepUpdateTrangThaiRequest;
    const response: IBaseResponse = yield danhSachTotNghiepApi.UpdateTrangThai(payload);
    if (response.is_success) {
        yield put(mainActions.UPDATE_TRANG_THAI_SUCCESS(response.data));
    } else {
        yield put(mainActions.UPDATE_TRANG_THAI_ERROR(response.message ?? "Có lỗi khi cập nhật trạng thái danh sách tốt nghiệp"));
    }
}

function* updateQuyetDinhWorker(action: IDanhSachTotNghiepActionTypes) : any {
    const request = action.payload as IDanhSachTotNghiepUpdateQuyetDinhRequest;
    const response: IBaseResponse = yield danhSachTotNghiepApi.UpdateQuyetDinh(request);
    if (response.is_success) {
        yield put(mainActions.UPDATE_QUYET_DINH_SUCCESS(response.data));
    } else {
        yield put(mainActions.UPDATE_QUYET_DINH_ERROR(response.message ?? "Có lỗi khi cập nhật quyết định tốt nghiệp"));
    }
}

function* updateSoHieuWorker(action: IDanhSachTotNghiepActionTypes) : any {
    const request = action.payload as IGenerateSoHieuRequest;
    const response: IBaseResponse = yield danhSachTotNghiepApi.UpdateSoHieu(request);
    if (response.is_success) {
        yield put(mainActions.UPDATE_SO_HIEU_SUCCESS(response.data));
    } else {
        yield put(mainActions.UPDATE_SO_HIEU_ERROR(response.message ?? "Có lỗi khi cập nhật số hiệu tốt nghiệp"));
    }
}
function* updateSoInQuyetDinhWorker(action: IDanhSachTotNghiepActionTypes): any {
    const request = action.payload as IGenerateSoInQuyetDinhRequest;

    try {
        const response: IBaseResponse = yield danhSachTotNghiepApi.UpdateSoInQuyetDinh(request);

        if (response.is_success) {
            yield put(mainActions.UPDATE_SO_IN_QUYET_DINH_SUCCESS(response.data));
            yield put(mainActions.LOAD_BY_DOT_XET_START(request.id_xet_tot_nghiep));
            yield put(
                rootActions.xetTotNghiep.xetTotNghiep.CLOSE_CAU_HINH_SO_IN_QUYET_DINH_MODAL(undefined)
            );
            NotifyHelper.Success("Cập nhật số in quyết định thành công");
        } else {
            yield put(mainActions.UPDATE_SO_IN_QUYET_DINH_ERROR(response.message ?? "Có lỗi khi cập nhật số in quyết định"));
            NotifyHelper.Error(response.message ?? "Có lỗi khi cập nhật số in quyết định");
        }
    } catch (err: any) {
        yield put(mainActions.UPDATE_SO_IN_QUYET_DINH_ERROR("Có lỗi khi cập nhật số in quyết định"));
        NotifyHelper.Error("Có lỗi khi cập nhật số in quyết định");
    }
}

function* updateSoVaoSoWorker(action: IDanhSachTotNghiepActionTypes) : any {
    const request = action.payload as IGenerateSoVaoSoRequest;
    const response: IBaseResponse = yield danhSachTotNghiepApi.UpdateSoVaoSo(request);
    if (response.is_success) {
        yield put(mainActions.UPDATE_SO_VAO_SO_SUCCESS(response.data));
    } else {
        yield put(mainActions.UPDATE_SO_VAO_SO_ERROR(response.message ?? "Có lỗi khi cập nhật số vào sổ tốt nghiệp"));
    }
}

function* huyKetQuaXetTotNghiepWorker(action: IDanhSachTotNghiepActionTypes) : any {
    const request = action.payload as IHuyKetQuaXetTotNghiepRequest;
    const response: IBaseResponse = yield danhSachTotNghiepApi.HuyKetQuaXets(request);
    if (response.is_success) {
        yield put(mainActions.HUY_KET_QUA_XET_TOT_NGHIEP_SUCCESS(response.data));
    } else {
        yield put(mainActions.HUY_KET_QUA_XET_TOT_NGHIEP_ERROR(response.message ?? "Có lỗi khi huỷ kết quả xét tốt nghiệp"));
    }
}